import React from 'react';
import Geocode from "react-geocode";
class Booking extends React.Component {
    state = {
        address: ''
    }

    componentDidMount() {
        Geocode.setApiKey("AIzaSyBNEoXVXR4BPWuvWGUteHu7eXf9pcFt-c0");
        Geocode.enableDebug();
    }

    handleTypeAddress = (data) => {
        let address = data.target.value;
        Geocode.fromAddress(`${data.target.value}`).then(
            response => {
                const { lat, lng } = response.results[0].geometry.location;
                this.props.enterLocation(lat, lng);
                this.props.location(address);
                document.getElementById('booking-form__location').classList.remove('booking__input-error');
            },
            error => {
                document.getElementById('booking-form__location').classList.add('booking__input-error');
            }
        );
    }

    render(){
        return (
          <React.Fragment>
              <input type="text" name="name" id="booking-form__location" onBlur={this.handleTypeAddress}/>
          </React.Fragment>
        );
    }
}

export default Booking;
